import NavBar from "./components/NavBar";
import MainContainer from "./components/MainContainer";
import Footer from "./components/Footer";
import Search from "./components/Search";
function App() {
  return (
    <div>
      <NavBar />
      <Search />
      <MainContainer />
      <Footer />
    </div>
  );
}

export default App;
